import type { ReactNode } from "react";

import type { SuggestionInsertSlot } from "../chat.types";
import { ChatContent } from "./chat-content";
import { ChatFooter, type ChatFooterVariant } from "./chat-footer";
import { ChatHeader, type ChatHeaderProps } from "./chat-header";
import { ChatScrollWrapper } from "./chat-scroll-wrapper";

export interface ChatProps {
  emptyComponent?: ReactNode;
  footerVariant?: ChatFooterVariant;
  header?: ChatHeaderProps | false;
  suggestionInsert?: SuggestionInsertSlot;
}

export const Chat = ({ emptyComponent, footerVariant = "default", header, suggestionInsert }: ChatProps = {}) => {
  return (
    <ChatScrollWrapper>
      {header === false ? null : <ChatHeader {...(header ?? {})} />}
      <ChatContent emptyComponent={emptyComponent} suggestionInsert={suggestionInsert} />
      <ChatFooter variant={footerVariant} />
    </ChatScrollWrapper>
  );
};
